import { ChevronDown, X } from "lucide-react";
import { useEffect,useState,useRef } from "react";
import { href, Link, useLocation } from "react-router-dom";
import Magnetic from "./magnetic";
import GillcoLogo from "./gillcologo";

const menuItems = [
  { label: "Home", href: "/"},
  { label: "Gillco Legacy", href: `/about`, dropdown: [
    { label: "About Gillco", href: `/about` }, { label: "Vision & Philosophy", href: `/vision` },
    { label: "Leadership", href: `/leadership` }, { label: "Journey", href: `/journey` },
    { label: "Awards & Recognitions", href: `/awards` },
  ]},
  { label: "Projects", href: `/projects`, dropdown: [
    { label: "All Projects", href: `/projects` }, { label: "Featured", href: `/projects/featured` },
    { label: "Residential", href: `/projects/residential` },
    { label: "Industrial", href: `/projects/industrial` },
  ]},
  { label: "Spotlight", href: `/spotlight` },
  { label: "Culture", href: `/culture/humans`, dropdown: [
    { label: "Humans of Gillco", href: `/culture/humans` }, { label: "CSR Initiatives", href: `/culture/csr` },
    // { label: "Events", href: `/culture/events` },
  ]},
  { label: "Careers", href: `/careers` },
  { label: "Contact", href: `/contact` },
];

// ===================== NAVIGATION (Hamburger from V11) =====================
const NavBar = ({ isHomePage = false }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);
  const location = useLocation();

  useEffect(() => { const h=()=>setScrolled(window.scrollY>50);window.addEventListener("scroll",h);return()=>window.removeEventListener("scroll",h) },[]);
  useEffect(() => { setMenuOpen(false); setExpandedItem(null) }, [location]);
  useEffect(() => { document.body.style.overflow=menuOpen?"hidden":""; return()=>{document.body.style.overflow=""} }, [menuOpen]);

  const showSolid = scrolled || !isHomePage;

  return (
    <>
      <nav className={`fixed top-0 w-full z-50 transition-all duration-500 ${showSolid ? "bg-white shadow-sm" : "bg-transparent"}`} data-testid="v13-navigation">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          <div className="flex items-center justify-between h-20 lg:h-24">
            <div data-testid="v13-nav-logo"><GillcoLogo variant={showSolid ? "dark" : "light"} /></div>
            <Magnetic>
              <button onClick={() => setMenuOpen(true)} className="p-2 group" data-testid="v13-hamburger-btn">
                <div className="flex flex-col gap-[6px]">
                  <span className={`block w-7 h-[2px] transition-all duration-300 ${showSolid ? "bg-[#0A0A0A]" : "bg-white"} group-hover:bg-[#C4A265] group-hover:w-5`} />
                  <span className={`block w-5 h-[2px] transition-all duration-300 ${showSolid ? "bg-[#0A0A0A]" : "bg-white"} group-hover:bg-[#C4A265] group-hover:w-7`} />
                  <span className={`block w-7 h-[2px] transition-all duration-300 ${showSolid ? "bg-[#0A0A0A]" : "bg-white"} group-hover:bg-[#C4A265] group-hover:w-5`} />
                </div>
              </button>
            </Magnetic>
          </div>
        </div>
      </nav>
      <div className={`fixed inset-0 z-[200] transition-all duration-700 ${menuOpen ? "visible" : "invisible"}`}>
        <div className={`absolute inset-0 bg-white transition-opacity duration-500 ${menuOpen ? "opacity-[0.98]" : "opacity-0"}`} onClick={() => setMenuOpen(false)} />
        <div className={`relative z-10 h-full flex flex-col transition-all duration-700 ${menuOpen ? "opacity-100" : "opacity-0"}`}>
          <div className="flex items-center justify-between px-6 md:px-12 lg:px-20 h-20 lg:h-24">
            <GillcoLogo variant="dark" />
            <Magnetic><button onClick={() => setMenuOpen(false)} className="w-12 h-12 rounded-full border border-[#0A0A0A]/15 hover:border-[#C4A265] flex items-center justify-center transition-all duration-300" data-testid="v13-close-menu"><X size={18} className="text-[#0A0A0A]" /></button></Magnetic>
          </div>
          <div className="flex-1 flex items-center justify-center">
            <div className="text-center space-y-1 max-w-lg w-full px-6">
              {menuItems.map((item, index) => (
                <div key={index} style={{ opacity: menuOpen ? 1 : 0, transform: menuOpen ? "translateY(0)" : "translateY(30px)", transition: `all 0.5s cubic-bezier(0.16,1,0.3,1) ${0.1 + index * 0.06}s` }}>
                  <div className="flex items-center justify-center gap-3 py-1">
                    <Link to={item.href} className="block text-3xl md:text-4xl lg:text-5xl font-light text-[#1a1a1a] hover:text-[#0A4F3B] transition-colors duration-300" style={{ fontFamily: "'Cormorant Garamond', serif" }} onClick={() => !item.dropdown && setMenuOpen(false)} data-testid={`v13-menu-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>{item.label}</Link>
                    {item.dropdown && <button onClick={() => setExpandedItem(expandedItem === index ? null : index)} className="text-[#1a1a1a]/30 hover:text-[#0A4F3B] transition-colors"><ChevronDown size={20} className={`transition-transform duration-300 ${expandedItem === index ? "rotate-180" : ""}`} /></button>}
                  </div>
                  {item.dropdown && expandedItem === index && (
                    <div className="mt-1 mb-2 space-y-1">{item.dropdown.map((sub, idx) => (<Link key={idx} to={sub.href} className="block text-base text-[#1a1a1a]/40 hover:text-[#0A4F3B] transition-colors" onClick={() => setMenuOpen(false)}>{sub.label}</Link>))}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="px-6 md:px-12 lg:px-20 py-8 flex flex-wrap justify-center gap-8 text-sm text-[#1a1a1a]/30" style={{ opacity: menuOpen ? 1 : 0, transition: "opacity 0.5s ease 0.6s" }}>
            <a href="tel:+917529019797" className="hover:text-[#0A4F3B] transition-colors">+91 75290 19797</a>
            <a href="mailto:helpdesk@gillcogroup.com" className="hover:text-[#0A4F3B] transition-colors">helpdesk@gillcogroup.com</a>
          </div>
        </div>
      </div>
    </>
  );
};
export default NavBar;